import { IS_SIDEBAR_TYPE_PROP } from './common/common-prop-names';

export abstract class BaseSidebarObject {
  key = '';
  [IS_SIDEBAR_TYPE_PROP] = true;
  version = 1;
}
